export const dressTypeOptions = [
  'Bridal',
  'Bridesmaids',
  'Little White Dress',
  'Evening / Mother of the Bride',
  'Accessories',
];
